import { render, staticRenderFns } from "./SPImage.vue?vue&type=template&id=069263d7&"
import script from "./SPImage.vue?vue&type=script&lang=ts&"
export * from "./SPImage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports